import { BiasType } from 'libs/end-to-end/src/bias-type';
import { Insight } from 'libs/end-to-end/src/insights';
import { KeyTakeawayHighlightType } from 'libs/end-to-end/src/key-takeaways';
import { TreatmentRecommendation } from 'libs/end-to-end/src/treatment';
import { fillArray } from 'libs/end-to-end/src/factories/fillArray';
import { rootCauseBinScatterControlledVsUncontrolledGroupResult } from 'libs/end-to-end/src/factories/rootCauseAnalysis.factory';
import { testCount } from 'libs/end-to-end/src/factories/testCount.factory';
import { insightHighlight } from 'libs/end-to-end/src/factories/insightHighlight.factory';

export const insight = (overrides?: Partial<Insight>): Insight => {
  return {
    confidencePercentage: 80,
    recommendations: [TreatmentRecommendation.Values.MostPopular],
    biasTypes: [BiasType.Values.Preference],
    type: KeyTakeawayHighlightType.Values.parity,
    groupResults: fillArray({
      length: 5,
      valueFn: () => rootCauseBinScatterControlledVsUncontrolledGroupResult(),
    }),
    dimension: 'some column header value',
    metric: 'some columnHeaderValue',
    referenceLevel: 'some column value',
    treatmentLevel: 'some column value',
    highlight: insightHighlight(),
    totalTestCount: testCount(),
    priority: 10,
    ...(overrides ?? {}),
  };
};
